export const FAST_PAY_TABS_MAN_SLUG_MAP: Record<string, string> = {
  young_european_muscular: 'luca-moretti-bnsbbr',
  old_european_muscular: 'rafael-ir5bux',
  young_european_tone: 'leo-maren',
  old_european_tone: 'alexander-wt1qiy',
  young_latino_tone: 'antonio-pzpplz',
  old_african_muscular: 'marcus-king-lawson',
  young_latino_muscular: 'emiliano-21mlez',
  young_european_slim: 'alex-djoduq',
  young_african_muscular: 'omako',
  young_asian_muscular: 'jae-6tknrn',
  young_asian_tone: 'kenzo-lee',
  middle_latino_tone: 'lorenzo-delgado',
  middle_european_plus_size: 'peter-l2tqd8',
  middle_latino_plus_size: 'pancho-q4ionu',
  middle_african_tone: 'jale-0uk3sz',
  middle_asian_tone: 'kenzo-lee',
};
